import { Text, View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { Button, Modal } from "../../../components";

const RegistrationFullModal = ({
  onReviewAvailability,
  visible,
  setVisible,
}: {
  onReviewAvailability: () => void;
  visible: boolean;
  setVisible: (value: boolean) => void;
}) => (
  <Modal
    visible={visible}
    HeaderComponent={
      <View className="flex-row mx-6 mt-6 items-center">
        <View className="flex-row">
          <Feather size={20} name="alert-triangle" />
          <Text className="bg-sky-white text-regular-normal font-700 px-2 pb-2">Session Availability Has Changed</Text>
        </View>
      </View>
    }
    onDismiss={() => setVisible(false)}
    FooterComponent={
      <View className="flex-row-reverse">
        <View className="mr-3">
          <Button
            className="mx-auto mb-3 bg-primary-lightest text-primary"
            onPress={() => {
              setVisible(false);
              onReviewAvailability();
            }}
            mode="secondary"
          >
            Review Availability
          </Button>
        </View>
      </View>
    }
  >
    <View className="mx-6 mb-3" testID="registration-full-modal">
      <Text className="bg-sky-white text-regular-normal font-500 pb-2">
        One or more sessions you've selected are now fully booked. Please update your registration using the updated session
        availability.
      </Text>
    </View>
  </Modal>
);

export default RegistrationFullModal;
